// web-vite/src/app/supabaseClient.ts
//
// Singleton Supabase client for TagBoard web. Hard-fails on missing env so
// misconfigurations are caught at boot, not at the first query.
//
// This module is the ONLY place that reads VITE_* env vars for Supabase.
// All other code imports the `supabase` export from here.

import {createClient, type SupabaseClient} from '@supabase/supabase-js'

const url     = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  throw new Error(
    '[TagBoard] Missing Supabase env vars: ' +
      'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required. ' +
      'Add them to web-vite/.env.local to run the app.',
  )
}

export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    // Persist the session in localStorage so a hard refresh keeps the user
    // logged in. Required for the auth gate to skip the LoginScreen after
    // the first sign-in. Tokens auto-refresh while the tab is open.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,  // we don't use magic-link / OAuth redirects yet
  },
})

// Default mine — every spatially-scoped query filters by mine_id. The id is
// the same UUID seeded in supabase/init.sql; can be overridden via env for
// multi-mine setups.
export const DEFAULT_MINE_ID =
  import.meta.env.VITE_DEFAULT_MINE_ID ?? '00000000-0000-0000-0000-000000000001'

if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.log('[TagBoard] Supabase client ready.')
}
